import React from 'react';
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';

interface PriceChartProps {
  data: { date: string; price: number }[];
  height?: number;
  color?: string;
}

export default function PriceChart({ data, height = 300, color = '#58a6ff' }: PriceChartProps) {
  return (
    <div className="bg-surface border border-border rounded-2xl p-4">
      <ResponsiveContainer width="100%" height={height}>
        <AreaChart data={data} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id="priceGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor={color} stopOpacity={0.3} />
              <stop offset="95%" stopColor={color} stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="#313131" />
          <XAxis
            dataKey="date"
            stroke="#6e7681"
            tick={{ fill: '#8b949e', fontSize: 11 }}
            tickLine={false}
          />
          <YAxis
            stroke="#6e7681"
            tick={{ fill: '#8b949e', fontSize: 11 }}
            tickLine={false}
            tickFormatter={(v) => `${v}€`}
          />
          <Tooltip
            contentStyle={{
              background: '#262626',
              border: '1px solid #313131',
              borderRadius: 8,
              color: '#c9d1d9',
              fontSize: 13,
            }}
            formatter={(value: any) => [`${Number(value).toFixed(2)}€`, 'Prix']}
          />
          <Area
            type="monotone"
            dataKey="price"
            stroke={color}
            strokeWidth={2}
            fill="url(#priceGradient)"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
